import React, { useEffect, useRef, useState } from "react";
import Iconfont from "@base/lib/Iconfont";
import delay from 'base/utils/delay';
import type { IImage } from 'base/interfaces/product';
import Image from '@base/lib/ThemeImage';
import styles from "./index.module.less";

interface IProps {
    pageSize?: number;
    imagesList?: IImage[];
    onClick?: (e: IImage) => void;
    alt?: string;
}

const ImagesListSwiper: React.FC<IProps> = (props) => {
    const {
        pageSize = 5,
        imagesList = [],
        onClick,
        alt,
    } = props
    const imagesWrapRef = useRef<HTMLDivElement>(null)
    const imagesListRef = useRef<HTMLDivElement>(null)
    const [atIndex, setAtIndex] = useState<number>(0)
    const [currentSwiperIndex, setCurrentSwiperIndex] = useState<number>(0)
    const [isScrollIng, setIsScrollIng] = useState<boolean>(false)

    // 滚动距离
    const swiperListHandle = async () => {
        if (isScrollIng) {
            return
        }
        const imagesWrapEl = imagesWrapRef?.current as HTMLDivElement
        const imagesListEl = imagesListRef?.current as HTMLDivElement
        imagesListEl.style.transform = `translateX(-${currentSwiperIndex * imagesWrapEl.clientWidth}px)`

        await delay(500)
        setIsScrollIng(false)
    }

    // 左右按钮
    const onClickArrowBtn = (config: {
        dir: 'left' | 'right'
    }) => {
        if (isScrollIng) {
            return
        }
        const { dir = 'left' } = config

        const totalIndex = Math.ceil(imagesList.length / pageSize) - 1
        let newIndex

        if (dir === "left") {
            newIndex = currentSwiperIndex === 0 ? totalIndex : currentSwiperIndex - 1
        } else {
            newIndex = currentSwiperIndex === totalIndex ? 0 : currentSwiperIndex + 1
        }
        setCurrentSwiperIndex(newIndex)
    }

    useEffect(() => {
        swiperListHandle().then()
    }, [atIndex, currentSwiperIndex])

    useEffect(() => {
        setAtIndex(0)
        setCurrentSwiperIndex(0)
    }, [imagesList])

    return (
        <div className={`${styles.imagesSmall} relative`}>
            {imagesList?.length > pageSize && (
                <>
                    <div
                        className={`${styles.arrowLeft} absolute pointer`}
                        onClick={() => onClickArrowBtn({ dir: 'left' })}
                    >
                        <Iconfont className={`${styles.iconArrow} icon-arrow-left`}/>
                    </div>
                    <div
                        className={`${styles.arrowRight} absolute pointer`}
                        onClick={() => onClickArrowBtn({ dir: 'right' })}
                    >
                        <Iconfont className={`${styles.iconArrow} icon-arrow-right`}/>
                    </div>
                </>
            )}

            <div ref={imagesWrapRef} className={styles.imagesWrap}>
                <div ref={imagesListRef} className={`${styles.imagesList} relative`}>
                    {
                        imagesList?.map((item: IImage, index: number) => {
                            return (
                                <li
                                    key={index}
                                    className={`${styles.imageItem} ${
                                        index === atIndex ? styles.on : ""
                                    }`}
                                    onClick={() => {
                                        onClick?.(item)
                                        setAtIndex(index)
                                    }}
                                >
                                    {/* 图片、视频缩略图 */}
                                    <div className={`${styles.item} pointer relative`}>
                                        <Image
                                            src={item.cover}
                                            width={92}
                                            alt={item.altText || alt}
                                        />
                                        {/*视频图标 1：视频 */}
                                        {item.type === 1 && (
                                            <div className={styles['video-tag']}>
                                                <div className={styles['video-tag-img']}>
                                                    <Image
                                                        src="asset/width-60/picture/bbeb3488bee3af0114fd3b0c6e31ce0c.png"
                                                        width={30}
                                                        background={false}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </li>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default React.memo(ImagesListSwiper);
